import React, { Component } from 'react'
import styled from 'styled-components'
import media from '../../styles/media'
import Icon from '../../components/icon/icon'

const SimpleTitleContainer = styled.div``

const SimpleTitleWrapper = styled.p`
  font-family: Raleway;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #3c4252;
  margin-top: 0;
  ${media.md`  
    font-size: 25px;
  `};
`

const StyledDecorationLeft = styled(Icon)`
  fill: #40b4e4;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 292px;
  height: 300px;
`

function InterestTitle(props) {
  const { title } = props
  return (
    <SimpleTitleContainer>
      <StyledDecorationLeft
        className="d-none d-md-block"
        name="decoration-left"
      />
      <SimpleTitleWrapper>¿Te interesa el producto {title}?</SimpleTitleWrapper>
    </SimpleTitleContainer>
  )
}

export default InterestTitle



// WEBPACK FOOTER //
// ./src/components/text/interestTitle.js